export default __webpack_public_path__ + "static/media/ReportBottom.4a058544.svg";